<template>
    <div>
        <div class="sousuo" style="width: 100%">
            <div style="width: 450px" class="yl-flex flex_between">
                <Input placeholder="搜索客户姓名/电话" v-model="name" style="width: 300px">
                    <i-button slot="append" icon="ios-search"></i-button>
                </Input>
                <Button class='ivu-btn-circle' type="primary" @click="getList">搜索</Button>
                <Button class='ivu-btn-circle' @click="initSearch">重置</Button>
            </div>
            <div style="width: 250px; text-align: right">
                <span style="color: #54A1F3; margin-right: 10px;cursor: pointer;" @click="addSeaBatch" v-if="menuName == 'three_add_recycle_client' && userInfo.menuList.mareLiberum.media_set_poolSeaCustomer">批量加入公海</span>
                <Button class="ivu-btn-circle" v-if="userInfo.menuList.mareLiberum.media_set_poolGiveOutCustomer" @click="giveOutModal = true" type="primary">批量分配客户</Button>
            </div>
        </div>
        <div class="multiple">
            <div class="child-div">客户类别</div>
            <RadioGroup v-model="clientType">
                <Radio label="1"><span>个人</span></Radio>
                <Radio label="2"><span>企业</span></Radio>
            </RadioGroup>
        </div>
        <div class="multiple">
            <div class="child-div">时间维度</div>
            <CheckboxGroup v-model="timeDimension">
                <Checkbox label="1" v-model = "notFollowTime"><span>未跟进时间</span></Checkbox>
                <Checkbox label="2"><span>申请时间</span></Checkbox>
				<Checkbox label="8"><span>公共池回收时间</span></Checkbox>
            </CheckboxGroup>
        </div>
		<div class="multiple" v-if="notFollowTime">
			<div class="child-div">未跟进时间</div>
			<Input  v-model="notFollowTimeValue" placeholder="单位/天" style="width: 80px" />
		</div>
		<div class="multiple">
			<div class="child-div">时间区间</div>
			<RadioGroup v-model="timePeriod">
				<Radio label="0"><span>不限</span></Radio>
				<Radio label="1"><span>今日</span></Radio>
				<Radio label="2"><span>昨日</span></Radio>
				<Radio label="3"><span>本周</span></Radio>
				<Radio label="4"><span>上周</span></Radio>
				<Radio label="5"><span>本月</span></Radio>
				<Radio label="6"><span>上月</span></Radio>
				<Radio label="7"><span>自定义</span></Radio>
				<DatePicker v-if="timePeriod == '7' " :value="timePeriodDate" @on-change="timePeriodDateChange"
					type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>
			</RadioGroup>
		</div>
        <div class="multiple" v-if="foldShow">
            <div class="child-div">申请条件</div>
            <CheckboxGroup v-model="apply">
                <Checkbox label="full_house"><span>全款房</span></Checkbox>
                <Checkbox label="monthly_housing"><span>月供房</span></Checkbox>
                <Checkbox label="all_models"><span>全款车</span></Checkbox>
                <Checkbox label="monthly_car_supply"><span>月供车</span></Checkbox>
                <Checkbox label="accumulation_fund"><span>公积金</span></Checkbox>
                <Checkbox label="social_security"><span>社保</span></Checkbox>
                <Checkbox label="salary"><span>工资</span></Checkbox>
                <Checkbox label="company_bonus"><span>分红</span></Checkbox>
                <Checkbox label="identity_of_borrower_big_company"><span>企业主</span></Checkbox>
                <Checkbox label="identity_of_borrower_small_company"><span>个体户</span></Checkbox>
                <Checkbox label="identity_of_borrower_officials"><span>公职人员</span></Checkbox>
                <Checkbox label="identity_of_borrower_office"><span>上班族</span></Checkbox>
                <Checkbox label="identity_of_borrower_unemployed"><span>肄业</span></Checkbox>
                <Checkbox label="micro_loan"><span>微粒贷</span></Checkbox>
                <Checkbox label="commercial_insurance"><span>保单</span></Checkbox>
                <Checkbox label="zm_credit_score"><span>信用卡</span></Checkbox>
                <Checkbox label="zm_credit_score"><span>芝麻信用</span></Checkbox>
                <Checkbox label="liability_requirements"><span>负债</span></Checkbox>
            </CheckboxGroup>
        </div>
		<div class="multiple" v-if="foldShow">
			<div class="child-div">媒体代码</div>
			<CheckboxGroup v-model="media" style="width: 80%">
				<Checkbox :label="item.value" v-for="(item, index) in categoryList"><span>{{item.name}}</span></Checkbox>
			</CheckboxGroup>
		</div>
		<div v-if="foldShow" class="multiple">
			<div class="child-div">客户标签</div>
			<CheckboxGroup v-model="is_offer">
				<Checkbox label="1"><span>潜在需求</span></Checkbox>
				<Checkbox label="2"><span>否认申请</span></Checkbox>
				<Checkbox label="3"><span>异地客户</span></Checkbox>
				<Checkbox label="4"><span>不需要</span></Checkbox>
				<Checkbox label="5"><span>有逾期</span></Checkbox>
				<Checkbox label="6"><span>捣乱申请</span></Checkbox>
				<Checkbox label="7"><span>同行</span></Checkbox>
				<Checkbox label="8"><span>无条件</span></Checkbox>
				<Checkbox label="9"><span>查询超</span></Checkbox>
				<Checkbox label="10"><span>白户</span></Checkbox>
				<Checkbox label="11"><span>黑户</span></Checkbox>
			</CheckboxGroup>
		</div>		
        <div v-if="foldShow" style="text-align: center;color: #277dd3; font-weight: bold;"><span
                style="cursor: pointer;" class="icon iconfont icon-shangla" @click="foldShow=!foldShow"></span></div>
        <div v-if="!foldShow" style="text-align: center; color: #277dd3; font-weight: bold;"><span
                style="cursor: pointer;" class="icon iconfont icon-shangla1" @click="foldShow=!foldShow"></span></div>

        <div class="multiple" style="width: 100%">
            <Table :columns="columns" :data="datas" size="small" ref="table" style="width: 100%">
                <template slot-scope="{ row }" slot="name">
                    <div style="display: flex; align-items: center;">
                        <div v-if="row.type == 1 "
                             style="width: 20px; height: 20px; line-height: 20px; background-color: #14BD98; color: #FFFFFF; border-radius: 50%; text-align: center;">
                            个
                        </div>
                        <div v-if="row.type == 2 "
                             style="width: 20px; height: 20px; line-height: 20px; background-color: #0C92F4; color: #FFFFFF; border-radius: 50%; text-align: center;">
                            企
                        </div>
                        <div style="display: flex;flex-direction: column; align-items: center;">
                            <span :class="{grey:row.has_follow == true}">{{row.name}}</span>
                            <span :class="{grey:row.has_follow == true}">{{row.phone | getPhoneNumber}}</span>
                        </div>
                    </div>
                </template>
                <template slot-scope="{ row }" slot="sex">
                    <span :class="{grey:row.has_follow == true}">{{row.sex_name}}</span>
                </template>
                <template slot-scope="{ row }" slot="age">
                    <span :class="{grey:row.has_follow == true}">{{row.ext_info.age}}</span>
                </template>
                <template slot-scope="{ row }" slot="media">
                    <span :class="{grey:row.has_follow == true}">{{row.media_name}}</span>
                </template>
                <template slot-scope="{ row }" slot="need_limit">
                    <span :class="{grey:row.has_follow == true}">{{row.loans_money}}</span>
                </template>
                <template slot-scope="{ row }" slot="level">
                    <span :class="{grey:row.has_follow == true}">{{row.start_name}}</span>
                </template>
                <template slot-scope="{ row }" slot="created_at">
                    <span :class="{grey:row.has_follow == true}">{{row.applied_at}}</span>
                </template>
                <template slot-scope="{ row }" slot="recycle_time">
                    <span :class="{grey:row.has_follow == true}">{{row.collect_at}}</span>
                </template>
                <template slot-scope="{ row }" slot="not_follow_time">
                    <span :class="{grey:row.has_follow == true}">{{row.updated_at}}</span>
                </template>
                <template slot-scope="{ row }" slot="history_state">
                    <span :class="{grey:row.has_follow == true}">{{row.status_name}}</span>
                </template>
                <template slot-scope="{ row }" slot="follow_number">
                    <span :class="{grey:row.has_follow == true}">{{row.follow_times}}</span>
                </template>
				<template slot-scope="{ row }" slot="entrust">
					<div v-for="(item,index) in row.entrust" style="margin: 3px 0" :key="index">{{item.ext_info.remark}}  {{item.created_at}}
					</div>
					<div v-if="row.entrust.length == 0">无</div>
				</template>
                <template slot-scope="{ row }" slot="operation">
                    <div style="display: flex; flex-direction: column; align-items: center; height: 60px; justify-content: space-around;">
                        <span @click="getCustomer" :data-id="row.id"  v-if="userInfo.menuList.mareLiberum.media_set_poolGetCustomer" style="color: #FFFFFF; cursor: pointer; background-color: #02A3E0; border-radius: 10px; width: 80px; text-align: center;">领取客户</span>
                        <span @click="addSea" :data-id="row.id" style="color: #63B3E6; cursor: pointer;" v-if="userInfo.menuList.mareLiberum.media_set_poolSeaCustomer && row.collect_times > 3">加入公海</span>
                    </div>
                </template>
            </Table>
        </div>
        <div class="pager">
            <Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts" @on-page-size-change="changeSize" :current="page" @on-change="changePage" size="small" show-elevator/>
        </div>
		<!-- 选择分配人 -->
		<Modal v-model="giveOutModal" width="650" title="选择分配人">
			<div class="multiple" style="margin-top: 0">
				<div class="child-div in-block">分配给</div>
				<CheckboxGroup v-model="giveOutUid" class="in-block" style="width: 80%">
                    <Checkbox v-for="item in userList" :label="item.id"><span>{{item.name}}</span></Checkbox>
				</CheckboxGroup>
			</div>
			<div slot="footer">
				<Button type="primary" @click="giveOutBatch">确定</Button>
			</div>
		</Modal>

    </div>
</template>
<script>
	import {getList, giveOut,addSea} from "../../api/client";
    import {getAllMediumCode} from "../../api/runSet";
	import {mapActions, mapGetters} from "vuex";

    import {
        getUserList
    } from '@/api/user'

	export default {
        name: "PublicPond",
        components: {},
		props: {
			menuName: {
				type: String
			}
		},
        data() {
            return {
                foldShow: false,
                status: 0,
                followUid: [],
                loanMoney: 0,
                start: [],
                pageSize: 20,
                pageSizeOpts: [20,50,100,500],
				userList: [],
                giveOutId: '',
				giveOutUid: [],
				giveOutModal: false,
                modal: false,
                count: 0,
                page: 1,
                name: '',
                timeDimension: [],
                clientType: '',
                timePeriod: '0',
				media: [],
				is_offer: [],
                apply: [],
                timePeriodDate: [],
				notFollowTime: false,
				notFollowTimeValue:'',
				categoryList: [],
                datas: [],
                columns: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        "title": "跟进人",
                        "key": "follow_name",
                        "minWidth": 90,
                        filters: [],
                        filterMultiple: false,
                        filterRemote(value, row) {
                            this.mySearchByFollow(value);
                        }
                    },
                    {
                        "title": "客户",
                        "slot": "name",
                        "minWidth": 130
                    },
                    {
                        "title": "性别",
                        "slot": "sex",
                        "minWidth": 60,
                    },
                    {
                        "title": "年龄",
                        "slot": "age",
                        "minWidth": 60,
                    },
                    {
                        "title": "媒体代码",
                        "slot": "media",
                        "minWidth": 100
                    },
					{
						"title": "跟进记录",
						// "key": "entrust",
						slot: 'entrust',
						"width": 220
					},					
                    {
                        "title": "需求额度",
                        "slot": "need_limit",
                        "minWidth": 100,
                        filters: [{value:1,label:'1000以下'},{value:2,label:'1千-1万'},{value:3,label:'1万-2万'},{value:4,label:'2万-3万'},{value:5,label:'3万以上'},],
                        filterMultiple: false,
                        filterRemote(value, row) {
                            this.mySearchByMoney(value);
                        }
                    },
                    {
                        "title": "星级",
                        "slot": "level",
                        "minWidth": 80,
                        filters: [{label:'0星',value:'0'},{label:'1星',value:'1'},{label:'2星',value:'2'},{label:'2+星',value:'3'},{label:'3星',value:'4'},{label:'4星',value:'5'}],
                        filterMultiple: false,
                        filterRemote(value, row) {
                            this.mySearchByStart(value);
                        }
                    },

                    {
                        "title": "申请时间",
                        "slot": "created_at",
                        "minWidth": 110,
                        "sortable": true
                    },
                    {
                        "title": "回收时间",
                        "slot": "recycle_time",
                        "minWidth": 110,
                        "sortable": true
                    },
                    {
                        "title": "最近跟进时间",
                        "slot": "not_follow_time",
                        "minWidth": 130,
                        "sortable": true
                    },
                    {
                        "title": "历史状态",
                        "slot": "history_state",
                        "minWidth": 100,
                        filters: [{label:'待处理',value:'1'},{label:'待跟进',value:'2'},{label:'邀约中',value:'3'},{label:'待上门',value:'4'}],
                        filterMultiple: false,
                        filterRemote(value, row) {
                            this.mySearchByStatus(value);
                        }
                    },
                    {
                        "title": "跟进次数",
                        "slot": "follow_number",
                        "minWidth": 100,
                        filters: [{value:1,label:'0次'},{value:2,label:'1-3次'},{value:3,label:'4-10次'},{value:4,label:'11-20次'},{value:5,label:'20次以上'},],
                        filterMultiple: false,
                        filterMethod(value, row) {
                            if (value == 1) {
                                return row.follow_times == 0;
                            } else if (value == 2) {
                                return row.follow_times > 0 && row.follow_times <= 3;
                            } else if (value == 3) {
                                return row.follow_times > 3 && row.follow_times <= 10;
                            } else if (value == 4) {
                                return row.follow_times > 10 && row.follow_times <= 20;
                            } else if (value == 5) {
                                return row.follow_times > 20;
                            }
                        }
                    },
                    {
                        "title": "操作",
                        "slot": "operation",
                        "minWidth": 100
                    }
                ],
            }
        },
		computed: {
            ...mapGetters(['token', 'userInfo']),
		},
		mounted: function () {
			this.loadData();
			this.getList();
		},
		watch: {
			menuName() {
				this.loadData();
				this.getList();
			},
		},
        filters: {
            getPhoneNumber(phone) {
                const newPhone = phone.substring(0, 3) + '****' + phone.substring(7, 11)
                return newPhone
            },
        },
        methods: {
            mySearchByStatus(status) {
                this.status = status[0];
                this.page = 1;
                this.getList();
            },
            mySearchByFollow(followUid) {
                this.followUid = followUid;
                this.page = 1;
                this.getList();
            },
            mySearchByMoney(loanMoney) {
                this.loanMoney = loanMoney[0];
                this.page = 1;
                this.getList();
            },
            mySearchByStart(start) {
                this.start = start;
                this.page = 1;
                this.getList();
            },
			...mapActions([
				'handleLogOut',
			]),
			search() {
				this.page = 1;
				this.getList();
			},
            timePeriodDateChange(e) {
                this.timePeriodDate = e
            },
            initSearch() {
				this.clientType = '';
				this.timeDimension = [];
				this.timePeriod = '';
				this.notFollowTime = false;
				this.timePeriodDate = [];
				this.apply = [];
				this.media = [];
            },
			async loadData() {
				let that = this;
				that.initSearch();
				var data = {token: this.token};
				let res = await getAllMediumCode(that, data);
				if (res.code == 1) {
					that.categoryList = res.data.list;
				}
				var data = {
					token: that.token,
					getSelf: 1
				};
				res = await getUserList(that, data);
				if (res.code == 1) {
					that.userList = res.data.list;
                    that.columns[1].filters = res.data.list;
				}
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
            changeSize(e) {
                this.pageSize = e;
                this.getList();
            },
			async getList() {
				let that = this;
				var data = this.$data;
				data.menu = 'media_set';
				data.token = this.token;
                data.limit = this.pageSize;
				data.page = this.page;
				data.orderBy = 'updated_at desc'
				let res = await getList(that, data);
				that.datas = res.data.list;
				that.count = res.count;
			},
			addSea(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				this.$Modal.confirm({
					title: '确认加入公海吗？',
					onOk: async () => {
						let res = await addSea(that, {token: that.token, id: id});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.getList();
						}
					}
				})
			},
            addSeaBatch() {
                let that = this;
                let selectTion = this.$refs['table'].getSelection();
                var ids = [];
                selectTion.forEach(function (e) {
                    ids.push(e.id);
                })
                this.$Modal.confirm({
                    title: '确认批量加入公海吗？',
                    onOk: async () => {
                        let res = await addSea(that, {token: that.token, id: ids});
                        if (res.code == 1) {
                            that.$Message.success(res.msg);
                            that.getList();
                        }
                    }
                })
            },
            getCustomer(e) {
                var that = this;
                this.giveOutId = e.currentTarget.dataset.id;
                this.$Modal.confirm({
                    title: '确认领取该客户吗吗？',
                    onOk: async () => {
                        that.giveOutUid = that.userInfo.id;
                        that.giveOutBatch();
                    }
                })
            },
			giveOutBatch() {
                var that = this;
			    if (this.giveOutId != '') {
			        var ids = this.giveOutId;
                } else {
                    let selectTion = this.$refs['table'].getSelection();
                    var ids = [];
                    selectTion.forEach(function (e) {
                        ids.push(e.id);
                    })
                }
				let data = {ids: ids,uid: that.giveOutUid,token: that.token}
				that.throttle(async function () {
					let res = await giveOut(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.giveOutId = '';
						that.giveOutModal = false;
						that.getList();
					}
				}, 2000);
			},
        },


    }
</script>
<style scoped lang="less">
    .red {
        color: red;
    }

    .multiple {
        display: flex;
        justify-content: left;
        margin-top: 10px;

        .child-div {
            width: 70px;
            height: 20px;
            margin-right: 30px;
            text-align-last: justify;
        }
    }

    .hong {
        color: #F56171;
        font-weight: bold;
    }

    .lan {
        color: #124386;
        font-weight: bold;
    }

    .sousuo {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .yl-flex {
        display: flex;
    }

    .flex_between {
        align-items: flex-start;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }

    .ivu-table-header thead tr th {
        text-align: center !important;
    }

    .ivu-table-cell {
        padding-left: 2px;
        padding-right: 2px;
        text-align: center;
    }

    .ivu-table table {
        width: 100% !important;
    }

    .green-bg {
        background: #18bc9c;
    }

    .blue-bg {
        background: #54A1F3;
    }

    .person {
        font-size: 14px;
        color: white;
        border-radius: 50%;
        width: 22px;
        height: 20px;
    }

    .in-block {
        display: inline-block;
    }
    .grey{
        color: #aba8a8;
    }
</style>
